import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    defaultValue: Yup.string().required('default value is required'),
    userAttribute: Yup.string().required('user attribute is required'),
});
